import { render } from "./CardRenderData.vue?vue&type=template&id=338f863d&ts=true"
import script from "./CardRenderData.vue?vue&type=script&lang=ts"
export * from "./CardRenderData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__